<div>
    <span *ngFor="let r of colorStars" class="stars-wrap"><mat-icon>star</mat-icon></span>
    <span class="gray-wrap">
            <span *ngFor="let r of grayStars"><mat-icon>star</mat-icon></span>
    </span>
</div>




// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/stars/stars.component.html